import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

var SvgStar = function SvgStar(_a) {
  var title = _a.title,
    desc = _a.desc,
    titleId = _a.titleId,
    descId = _a.descId,
    props = __rest(_a, ["title", "desc", "titleId", "descId"]);
  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  props['aria-labelledby'] = ariaLabelledBy;
  return jsxs("svg", __assign({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !!ariaLabelledBy
  }, props, {
    children: [!!title && jsx("title", __assign({
      id: titleId
    }, {
      children: title
    }), void 0), !!desc && jsx("desc", __assign({
      id: descId
    }, {
      children: desc
    }), void 0), jsx("path", {
      d: "M5.87231 2.05054C6.09315 0.942093 7.48915 0.568036 8.23462 1.41756L10.3194 3.79327C10.6154 4.13061 11.0585 4.30069 11.5042 4.24808L14.6431 3.87754C15.7655 3.74505 16.5527 4.95713 15.9751 5.92863L14.3599 8.64548C14.1305 9.03126 14.1057 9.5052 14.2935 9.91285L15.6158 12.7836C16.0887 13.8102 15.1792 14.9334 14.0768 14.6843L10.9938 13.9877C10.556 13.8887 10.0976 14.0116 9.76788 14.3161L7.44623 16.4609C6.61604 17.2279 5.26679 16.7099 5.16303 15.5845L4.87284 12.4371C4.83164 11.9902 4.57316 11.5922 4.18164 11.3727L1.4244 9.82748C0.438449 9.27492 0.514087 7.83166 1.55239 7.38519L4.45605 6.13662C4.86836 5.95932 5.16703 5.5905 5.25473 5.15033L5.87231 2.05054Z",
      fill: "currentColor"
    }, void 0)]
  }), void 0);
};

export { SvgStar as default };
